const baseAssets = {
  loadingLyric: [
    "Chipi，",
    "chipi，",
    "chapa，",
    "chapa\n",
    "Dubi，",
    "dubi，",
    "daba，",
    "daba\n",
    "Mágico，",
    "mi，",
    "dubi，",
    "dubi\n",
    "boom，",
    "boom，",
    "boom，",
    "boom\n",
    "Chipi，",
    "chipi，",
    "chapa，",
    "chapa\n",
    "Dubi，",
    "dubi，",
    "daba，",
    "daba\n",
    "Mágico，",
    "mi，",
    "dubi，",
    "dubi\n",
    "booooooooooooooom\n",
  ],
};

export { baseAssets };
